import colors from "./colors";
import fonts from "./fonts";
import styles from "./styles";
export const defaultStyles = {
  colors,
  fonts,
  styles,
};